<template>
    <div id="games-tab" class="container h-100">
        <div class="col-md-6 list-holder h-100 m-auto">

            <div @click="$emit('changeTab','challenge');btnSfx();" href="#" class="challenges animate__animated animate__bounceIn">
                <div class="ch-bg-content">
                    <span class="bear-left animate__animated animate__fadeInLeft"><i></i></span>
                    <span class="bear-right animate__animated animate__fadeInRight"><i></i></span>
                    <div class="ch-content animate__animated animate__fadeInUp animate__delay-0_5s">
                        <b-button v-if="challengeAccessible" @click.stop.prevent="$emit('changeTab','challenge');btnSfx();" class="btn btn-primary btn-lg pl-3 pr-3 mb-2">{{ $t('home.home_challenge_play_btn') }}</b-button>     
                        <span v-else v-html="$t('home.challenge_no_data')"></span>
                    </div>
                    <a @click.stop.prevent="challengesInfo();btnSfx();" href="#" class="info-btn animate__animated animate__zoomIn animate__delay-1s"><img src="/images/challenges/info-btn.png" height="22"/></a>
                </div>
                <div class="ch-title"><span>{{ $t('home.home_challenge_title') }}</span></div>
            </div>

            <div @click="openSuperChallenge();btnSfx();" href="#" class="super-challenge animate__animated animate__bounceIn">
                <div class="ch-bg-content">
                    <span class="house-left animate__animated animate__fadeInDown animate__delay-1s"><i></i></span>
                    <span class="bird-right animate__animated animate__fadeInUp animate__delay-1s"><i></i></span>
                    <div class="ch-content animate__animated animate__fadeInUp animate__delay-0_5s">
                        <div v-if="superChallenge == null" class="mb-3" v-html="$t('home.home_super_ch_no_data')"></div>
                        <template v-else-if="superChallenge.userApplied">
                            <img src="/images/home/super_challenges/check-icon.png" class="vh-5 mb-1">
                            <div>{{ $t('home.home_super_ch_applied') }}</div>
                        </template>
                        <span v-else-if="superChallenge.participantLimit <= superChallenge.participantCount" v-html="$t('home.home_super_ch_participant_limit')"></span>
                        <b-button v-else @click.stop.prevent="openSuperChallenge();btnSfx();" class="btn btn-primary mb-2 btn-lg pl-3 pr-3">{{ $t('home.home_super_ch_play_btn') }}</b-button>    
                    </div>
                </div>
                <div class="ch-title">
                    <span>
                        {{ $t('home.home_super_ch_title') }}
                        <div v-if="superChallenge != null"  v-html="$t('home.home_super_ch_subtitle', { time: sc_startTime })"></div>
                    </span>
                </div>
            </div>


            <div @click="openTriviaQuiz();btnSfx();" href="#" class="triviaquiz animate__animated animate__bounceIn">
                <div class="ch-bg-content">
                    <span class="bear-left animate__animated animate__fadeInLeft animate__delay-1s"><i></i></span>
                    <span class="tokens-right animate__animated animate__fadeInRight animate__delay-1s"><i></i></span>
                    <div class="ch-content animate__animated animate__fadeInUp animate__delay-0_5s">
                        <div v-if="quiz == null" class="mb-3" v-html="$t('home.home_quiz_no_data')"></div>
                        <div v-else-if="!!quiz.participantLimit || quiz.participantCount >= quiz.participantLimit" class="bm-3" v-html="$t('home.home_quiz_participant_limit')"></div>
                        <template v-else-if="quiz.userParticipationStatus != undefined">
                            <img src="/images/home/trivia_quiz/check-icon.png" class="vh-5 mb-1">
                            <div>{{ $t('home.home_quiz_applied') }}</div>
                        </template>
                        <b-button v-else @click.stop.prevent="openTriviaQuiz();btnSfx();" class="btn btn-primary mb-2 btn-lg pl-3 pr-3">{{ $t('home.home_quiz_play_btn') }}</b-button>     
                    </div>
                </div>
                <div class="ch-title">
                    <span>
                        {{ $t('home.home_quiz_title') }}
                        <div v-if="quiz != null" v-html="$t('home.home_quiz_subtitle', { time: tq_startTime })"></div>
                    </span>
                </div>
            </div>

        </div>
        <challenge-info-popup ref="challengesInfoPopup"></challenge-info-popup>
    </div>
</template>

<script>
import Vue from 'vue'

import ChallengeInfoPopup from '../components/ChallengeInfoPopup.vue';

const GamesTab = Vue.component('games-tab', {
    components: {
        ChallengeInfoPopup
    },
    tq_startDateTimer: null,
    sc_startDateTimer: null,
    data(){
    	return {
            sc_startTime: '00:00h',
            tq_startTime: '00:00h'
    	};
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        quiz() {
            return this.$store.state.trivia.quiz;
        },
        follow() {
            return this.$store.state.trivia.follow;
        },
        superChallenge() {
            return this.$store.state.superChallenge.obj;
        },
        challengeAccessible(){
            return this.$store.state.config.data.challengeAccessible;
        },
        networkTimeDiff(){
            return this.$store.state.config.networkTimeDiff;
        }
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        challengesInfo(){
            this.$refs.challengesInfoPopup.show();
        },

        openSuperChallenge(){
            if(this.superChallenge != null) 
                this.$emit('changeTab','super-challenge');
        },

        openTriviaQuiz(){
            if(this.quiz != null) 
                this.$emit('changeTab','triviaquiz');
        },

        formatTime(time){
            if(time < 0) time = 0; // fix negative
            let t = moment.duration(moment.utc(time).diff(moment.utc() + this.networkTimeDiff));

            if(t.asDays() > 1)
                return t.days()+"d"+(t.hours() > 0 ? " "+ this.pad2(t.hours())+ "h" : "");
            else if(t.hours() > 0)
                return this.pad2(t.hours()) + ":" + this.pad2(t.minutes())+"h";
            else if(t.minutes() > 0)
                return this.pad2(t.minutes()) + ":" + this.pad2(t.seconds())+"m";

            return '00:'+this.pad2(t.seconds())+"s";
        },
        pad2(number) {
            if(number < 0) number = 0;
            return (number < 10 ? '0' : '') + number
        },

        clearTQTimers(){
            if(this.tq_startDateTimer != null){
                clearInterval(this.tq_startDateTimer);
                this.tq_startDateTimer = null;
            }
        },
        clearSCTimers(){
            if(this.sc_startDateTimer != null){
                clearInterval(this.sc_startDateTimer);
                this.sc_startDateTimer = null;
            }
        }
    },

    mounted(){
        this.$store.dispatch('trivia/getQuiz');
        this.$store.dispatch('superChallenge/getChallenge');
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
        this.clearTQTimers();
        this.clearSCTimers();
    },

    watch:{
        quiz(){
            this.clearTQTimers();
            if(this.quiz != null){
                const $this = this;
                if(this.quiz.startDateTime != undefined){
                    this.tq_startTime = $this.formatTime(this.quiz.startDateTime); 
                    this.tq_startDateTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isBefore($this.quiz.startDateTime))
                            $this.tq_startTime = $this.formatTime($this.quiz.startDateTime);
                        else $this.tq_startTime = "00:00s";
                    }, 1000);
                }

                if (this.quiz.userParticipationStatus != undefined)
                    this.$store.dispatch('sound/bg','BG_QuizActive');
                else 
                    this.$store.dispatch('sound/bg','BG_QuizWait');
            }
            else this.$store.dispatch('sound/bg','BG_QuizWait');
        },

        superChallenge(){
            this.clearSCTimers();
            if(this.superChallenge != null){
                const $this = this;
                if(this.superChallenge.startDate != undefined){
                    this.sc_startTime = $this.formatTime(this.superChallenge.startDate); 
                    this.sc_startDateTimer = setInterval(() => { 
                        let nt = moment.utc() + $this.networkTimeDiff;
                        if(moment.utc(nt).isBefore($this.superChallenge.startDate))
                            $this.sc_startTime = $this.formatTime($this.superChallenge.startDate);
                        else $this.sc_startTime = "00:00s";
                    }, 1000);
                }
            }
        },
    }
});

export default GamesTab
</script>
